import React from 'react';
import { Container } from 'react-bootstrap';

function Year2 () {
    return (
        <div>
            <Container>
            <table class="table table-hover">
  <thead>
    <tr>
      <th scope="col">#</th>
      <th colspan="2">Name</th>
      <th scope="col">Download</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <th scope="row">1</th>
      <td colspan="2">DBMS NK</td>
      <td><a style={{textDecoration:'none'}} href='https://drive.google.com/file/d/1BPeTVH8NE2d3bZKp5dGUhTf9F6V_tdBz/view?usp=sharing' download> Download <i class="fa fa-download" style={{fontSize:'17px'}}></i></a></td>
    </tr>
    <tr>
        <th scope='row'>2</th>
        <td colspan="2">DCCN</td>
        <td><a style={{textDecoration:'none'}} href='https://drive.google.com/file/d/1qK6G9hj7NnfI5VdRCqpmC849rOKuwHJL/view?usp=sharing' download> Download <i class="fa fa-download" style={{fontSize:'17px'}}></i></a></td>
    </tr>
    <tr>
      <th scope="row">3</th>
      <td colspan="2">Discreate Mathematics Structure</td>
      <td><a style={{textDecoration:'none'}} href='https://drive.google.com/file/d/1jrbITVg6BeipvED80I5nHcuFAKt_jWNh/view?usp=sharing' download> Download <i class="fa fa-download" style={{fontSize:'17px'}}></i></a></td>
    </tr>
    <tr>
      <th scope="row">4</th>
      <td colspan="2">MEFA</td>
      <td><a style={{textDecoration:'none'}} href='https://drive.google.com/file/d/1i3hpu747GUEK8EL8ZWJCUt5yAr_wF2_q/view?usp=sharing' download> Download <i class="fa fa-download" style={{fontSize:'17px'}}></i></a></td>
    </tr>
    <tr>
      <th scope="row">5</th>
      <td colspan="2">Microprocessor</td>
      <td><a style={{textDecoration:'none'}} href='https://drive.google.com/file/d/10YRwgyJL4Y7WdRAMg_qla1VJmB1hSJ92/view?usp=sharing' download> Download <i class="fa fa-download" style={{fontSize:'17px'}}></i></a></td>
    </tr>
    <tr>
      <th scope="row">4</th>
      <td colspan="2">TOC</td>
      <td><a style={{textDecoration:'none'}} href='https://drive.google.com/file/d/1nAgxqe0w3yV-dsMTXofsU-s-bOVIeBKp/view?usp=sharing' download> Download <i class="fa fa-download" style={{fontSize:'17px'}}></i></a></td>
    </tr>
  </tbody>
</table>
</Container>
        </div>
    );
}

export default Year2;
